import { React, ts } from '_core';

import Chart from './chart';
import Form from './form';
import { DraftParams, Params } from './types';

type PredictedAndRealizedRiskVsTimeProps = {
  id: string;
  readOnly: boolean;
  widgetKey: string;
  mode: ts.enums.CHART_MODE_ENUM;
  params: Params | DraftParams;
  setParams: (_p: DraftParams) => void;

  fullScreen?: boolean;
  loadWidgetData: (_payload: ts.types.widgets.WidgetGetDataParams) => Promise<ts.types.widgets.WidgetGetDataResponse>;
  widgetPaths?: Record<'backtest_realized_predicted_forecast' | 'portfolio_realized_predicted_forecast', string>;

  title: string;
};

const PredictedAndRealizedRiskVsTime = ({
  id,
  readOnly,
  widgetKey,
  mode,
  params,
  setParams,
  loadWidgetData,
  widgetPaths,
  fullScreen,
  title,
}: PredictedAndRealizedRiskVsTimeProps) => {
  const fileKey = React.useMemo(
    () =>
      Object.keys(widgetPaths || {}).find((k) =>
        k.endsWith('_realized_predicted_forecast')
      ) as keyof typeof widgetPaths,
    [widgetPaths]
  );

  const renderJobComponent = () => (
    <Chart
      id={id}
      readOnly={readOnly}
      widgetKey={widgetKey}
      loadWidgetData={loadWidgetData}
      file={widgetPaths[fileKey]}
      fullScreen={fullScreen}
      title={title}
    />
  );

  return <>{mode == 'edit' ? <Form params={params} setParams={setParams} /> : renderJobComponent()}</>;
};

export default PredictedAndRealizedRiskVsTime;
